import type { StateCreator } from "zustand"

import type { AppState, AudioSlice } from "@/store/types"

export const createAudioSlice: StateCreator<AppState, [], [], AudioSlice> = (
  set,
) => ({
  audioFile: null,
  audioUrl: null,
  audioDuration: 0,
  isPlaying: false,
  setAudio: (audioFile, audioUrl, audioDuration) =>
    set((s) => {
      if (s.audioUrl && s.audioUrl !== audioUrl) URL.revokeObjectURL(s.audioUrl)
      return { audioFile, audioUrl, audioDuration }
    }),
  setPlaying: (isPlaying) => set({ isPlaying }),
})
